import { Stack } from '@mui/material';

import { NumberInputField } from '../../../../../components/textFieilds';

type EmLevelInputProps = {
  id?: string;
  name: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  value?: string | number;
};
function EmLevelInput({
  id,
  name,
  onChange,
  value,
  ...rest
}: EmLevelInputProps) {
  return (
    <Stack direction="row" spacing={0.5}>
      <NumberInputField
        defaultValue={name}
        InputProps={{
          readOnly: true,
        }}
        sx={{
          flex: 2 / 3,
          // background: '#e2e7ee',
        }}
      />
      <NumberInputField
        id={id}
        name={name}
        onChange={onChange}
        sx={{
          flex: 1 / 3,
        }}
        value={value}
        {...rest}
        inputProps={{
          min: 0,
          max: 100,
          maxLength: 4,
          sx: { textAlign: 'right' },
          step: 1,
        }}
      />
    </Stack>
  );
}
export default EmLevelInput;
